import * as ROUTES from './routes'

export const navMenu = [
  {
    children: [
      {
        children: [
          {
            key: ROUTES.PLAYERS_EPPP,
            label: 'Players - EPPP'
          },
          {
            disabled: true,
            key: ROUTES.COACHES_ECP,
            label: 'Coaches - ECP'
          },
          {
            key: ROUTES.MATCH_OFFICIALS_ERDP,
            label: 'Match Officials - ERDP'
          }
        ],
        label: 'STRATEGIC',
        type: 'group'
      },
      {
        children: [
          {
            disabled: true,
            key: ROUTES.HIGH_POTENTIAL,
            label: 'High Potential'
          },
          {
            key: ROUTES.PERFORMANCE_PATHWAY,
            label: 'Performance Pathway'
          },
          {
            disabled: true,
            key: ROUTES.DUTY_OF_CARE,
            label: 'Duty of Care'
          },
          {
            key: ROUTES.GOVERNANCE_AND_QA,
            label: 'Governance & QA'
          },
          {
            disabled: true,
            key: ROUTES.INNOVATION_AND_INSIGHTS,
            label: 'Innovation and Insights'
          },
          {
            disabled: true,
            key: ROUTES.EQUALITY_DIVERSITY_INCLUSION,
            label: 'Equality, Diversity & Inclusion'
          }
        ],
        label: 'OPERATIONAL',
        type: 'group'
      }
    ],
    id: 'football-development',
    key: ROUTES.FOOTBALL_DEVELOPMENT,
    title: 'Football Development'
  },
  {
    children: [
      {
        disabled: true,
        key: ROUTES.KPIS,
        label: 'KPIs'
      },
      {
        disabled: true,
        key: ROUTES.PLAYING_TIME,
        label: 'Playing Time'
      },
      {
        disabled: true,
        key: ROUTES.ATTENDANCE,
        label: 'Attendance'
      },
      {
        disabled: true,
        key: ROUTES.SUBSTITUTIONS,
        label: 'Substitutions'
      }
    ],
    id: 'football-operations',
    key: ROUTES.FOOTBALL_OPERATIONS,
    title: 'Football Operations'
  },
  {
    children: [
      {
        disabled: true,
        key: ROUTES.TRANSFERS,
        label: 'Transfers'
      },
      {
        disabled: true,
        key: ROUTES.PLAYER_REGISTRATIONS,
        label: 'Player Registrations'
      },
      {
        disabled: true,
        key: ROUTES.STAFF_REGISTRATIONS,
        label: 'Staff Registrations'
      }
    ],
    id: 'football-administration',
    key: ROUTES.FOOTBALL_ADMINISTRATION,
    title: 'Football Administration'
  }
]
